import { h } from 'preact';
import 'preact/debug';
import { useState } from 'preact/hooks';
import ItemsProvider from './ItemsProvider';
import PriceTag from './PriceTag';
import BundleDescription from './BundleDescription';
import AddToCartButton from './AddToCartButton';
import BundleItemList from './BundleItemList';

const BundlesApp = ({ items, bundle }) => {
  const [validItems] = useState(() => {
    return items.filter((item) => {
      return !item.product['error'];
    });
  });

  return (
    <section className="Bundle-App">
      <ItemsProvider items={validItems} bundle={bundle}>
        <PriceTag />
        <BundleDescription />
        <AddToCartButton
          helpText={`Please confirm that you've got everything you'd like in your bundle below `}
        />
        <BundleItemList />
        <div style={{ marginBottom: '1.2em' }}>
          <AddToCartButton />
        </div>
      </ItemsProvider>
    </section>
  );
};

export default BundlesApp;
